import { render, staticRenderFns } from "./MandatoryConsentComponent.vue?vue&type=template&id=e026cb22"
import script from "./MandatoryConsentComponent.vue?vue&type=script&lang=ts"
export * from "./MandatoryConsentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports